import React from 'react';
import { CloseIcon, Modal } from '../../components';
import classes from '../SampleRequest/selectedSamplesList.module.css';

var VideoPreviewModal = function VideoPreviewModal(_ref) {
  var toggleVideoModal = _ref.toggleVideoModal,
      isOpen = _ref.isOpen,
      item = _ref.item,
      resourceName = _ref.resourceName;
  var splitUrl = item.url.split('?');
  var searchParams = new URLSearchParams(splitUrl[1]);
  searchParams.set('autoplay', 1);
  var url = splitUrl[0] + '?' + (searchParams === null || searchParams === void 0 ? void 0 : searchParams.toString());
  return React.createElement(Modal, {
    isOpen: isOpen,
    size: "full",
    toggleModal: toggleVideoModal
  }, React.createElement("div", {
    className: "container grid-cols-12 h-full"
  }, React.createElement("div", {
    className: "flex justify-end py-12"
  }, React.createElement("button", {
    onClick: toggleVideoModal,
    "aria-label": "Close ".concat(resourceName, " video"),
    className: classes.closeButton
  }, React.createElement(CloseIcon, {
    isWhite: true
  }))), React.createElement("div", {
    className: "w-full text-center flex justify-center",
    style: {
      height: '80vh'
    }
  }, React.createElement("div", {
    className: "w-full h-full"
  }, React.createElement("iframe", {
    width: "100%",
    src: url,
    height: "100%",
    title: "".concat(resourceName, " video"),
    frameBorder: "0",
    allow: "autoplay; fullscreen",
    allowFullScreen: true,
    muted: true
  })))));
};

export default VideoPreviewModal;